import {createSelector} from 'reselect';
import {isIssueTypesAdminListFetched, isLoadingIssueTypesAdminList} from './issueTypes-selectors';
import {
  isIssueAttributesDefinitionsFetched,
  isIssueAttributesMappingsFetched,
  isLoadingIssueAttributesDefinitions,
  isLoadingIssueAttributesMappings
} from './issueAttributes-selectors';
import {
  getConfiguration,
  getCurrentDocument,
  getCurrentViewType,
  getOxygenMappings,
  getTargetUrn
} from './configuration-selectors';
import {viewTypes} from '../../constants/view-types';

export const getAccessToken = state => state.accessToken;

export const isFieldIssuesCustomizationDataFetched = createSelector(
  isIssueTypesAdminListFetched,
  isIssueAttributesDefinitionsFetched,
  isIssueAttributesMappingsFetched,
  (typesFetched, attrDefinitionsFetched, attrMappingsFetched) =>
    typesFetched && attrDefinitionsFetched && attrMappingsFetched
);

// Placing this last to verify all selectors have been initialized
export const getAppLoading = createSelector(
  getAccessToken,
  getTargetUrn,
  getOxygenMappings,
  getCurrentDocument,
  getConfiguration,
  getCurrentViewType,
  (accessToken, targetUrn, oxygen, document, configuration, viewType) => {
    const {jsonapi} = configuration;
    /**
     *  `null` is the initial state of accessToken, targetUrn, and document:
     *
     *  If targetUrn and document are strictly-equal to null, then the app is still "loading", because
     *  these values need to be configured in order to successfully make API requests.
     *
     *  If targetUrn is set to an empty string, then requests for an issues collection will not be filtered by targetUrn.
     *
     *  If document is set to an Object with a `version` property that is an empty string, then requests for an issues
     *  collection will not be filtered by document-version.
     */
    const documentViewLoading = viewType === viewTypes.DOCUMENT && (targetUrn === null || document === null);
    return documentViewLoading || !jsonapi || !oxygen;
  }
);

export const getFieldAdminPageDataLoading = createSelector(
  isLoadingIssueTypesAdminList,
  isLoadingIssueAttributesDefinitions,
  isLoadingIssueAttributesMappings,
  (issueTypesLoading, attributeDefinitionsLoading, attributeMappingsLoading) =>
    issueTypesLoading || attributeDefinitionsLoading || attributeMappingsLoading
);
